export const GET_PIPELINE = "GET_PIPELINE";
export const GET_PIPELINE_COMPLETED = "GET_PIPELINE_COMPLETED";
export const GET_PIPELINE_FAILED = "GET_PIPELINE_FAILED";

export const GET_EVENEMENT = "GET_EVENEMENT";
export const GET_EVENEMENT_COMPLETED = "GET_EVENEMENT_COMPLETED";
export const GET_EVENEMENT_FAILED = "GET_EVENEMENT_FAILED";

export const GET_EVENEMENT_CONSTANTS = "GET_EVENEMENT_CONSTANTS";
export const GET_EVENEMENT_CONSTANTS_COMPLETED = "GET_EVENEMENT_CONSTANTS_COMPLETED";
export const GET_EVENEMENT_CONSTANTS_FAILED = "GET_EVENEMENT_CONSTANTS_FAILED";

export const CREATE_EVENEMENT = "CREATE_EVENEMENT";
export const CREATE_EVENEMENT_COMPLETED = "CREATE_EVENEMENT_COMPLETED";
export const CREATE_EVENEMENT_FAILED = "CREATE_EVENEMENT_FAILED";

export const UPDATE_EVENEMENT = "UPDATE_EVENEMENT";
export const UPDATE_EVENEMENT_COMPLETED = "UPDATE_EVENEMENT_COMPLETED";
export const UPDATE_EVENEMENT_FAILED = "UPDATE_EVENEMENT_FAILED";

export const PATCH_EVENEMENT_STATUT = "PATCH_EVENEMENT_STATUT";
export const TRANSFORM_EVENEMENT = "TRANSFORM_EVENEMENT";
export const PATCH_GROUPED_STATUS_PIPELINE = "PATCH_GROUPED_STATUS_PIPELINE";

// Board complet (5 colonnes) — un seul appel
export const getPipeline = (chargeDeClientele = null) => {
  const params = {};
  if (chargeDeClientele) {
    params.charge_de_clientele = chargeDeClientele;
  }
  return {
    type: GET_PIPELINE,
    meta: {
      async: true,
      blocking: false,
      path: `/api/evenement/pipeline.json`,
      method: "GET",
      params,
    },
  };
};

export const getEvenement = (id) => ({
  type: GET_EVENEMENT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/${id}.json`,
    method: "GET",
    params: {},
  },
});

// Pré-remplissage d'un événement depuis un devis (commande groupée) orphelin.
export const getEvenementPrefill = (groupedId) => ({
  type: "GET_EVENEMENT_PREFILL",
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/prefill/${groupedId}.json`,
    method: "GET",
    params: {},
  },
});

export const getEvenementConstants = () => ({
  type: GET_EVENEMENT_CONSTANTS,
  meta: {
    async: true,
    blocking: false,
    path: `/api/evenement/constants.json`,
    method: "GET",
    params: {},
  },
});

export const createEvenement = (data) => ({
  type: CREATE_EVENEMENT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement.json`,
    method: "POST",
    body: data,
  },
});

export const updateEvenement = (id, data) => ({
  type: UPDATE_EVENEMENT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/${id}.json`,
    method: "PUT",
    body: data,
  },
});

export const ADD_EVENEMENT_NOTE = "ADD_EVENEMENT_NOTE";

// Journal de notes / échanges sur la demande
export const addEvenementNote = (id, contenu) => ({
  type: ADD_EVENEMENT_NOTE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/${id}/note.json`,
    method: "POST",
    body: { contenu },
  },
});

export const ADD_EVENEMENT_PIECE_JOINTE = "ADD_EVENEMENT_PIECE_JOINTE";

// Pièce jointe d'un événement : document uploadé (PDF, image…) ou email collé.
// L'endpoint attend du multipart, d'où `isFormData` (apiService retire alors
// l'en-tête Content-Type pour laisser le navigateur poser la boundary).
export const addEvenementPieceJointe = (id, { type, contenu = null, fichier = null }) => {
  const body = new FormData();
  body.append("type", type);
  if (contenu) body.append("contenu", contenu);
  if (fichier) body.append("fichier", fichier);

  return {
    type: ADD_EVENEMENT_PIECE_JOINTE,
    meta: {
      async: true,
      blocking: true,
      path: `/api/evenement/${id}/piece-jointe.json`,
      method: "POST",
      isFormData: true,
      body,
    },
  };
};

export const patchEvenementStatut = (id, statut) => ({
  type: PATCH_EVENEMENT_STATUT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/${id}/statut.json`,
    method: "PUT",
    body: { statut: statut },
  },
});

export const transformEvenement = (id) => ({
  type: TRANSFORM_EVENEMENT,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/${id}/transform.json`,
    method: "POST",
    body: {},
  },
});

// Changement de statut d'une carte devis (endpoint existant du BO)
export const patchGroupedStatusPipeline = (groupedOrderId, status) => ({
  type: PATCH_GROUPED_STATUS_PIPELINE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/pro/orders/grouped/${groupedOrderId}/status.json`,
    method: "PUT",
    body: { status: status },
  },
});

export const GET_EVENEMENT_BY_GROUPED = "GET_EVENEMENT_BY_GROUPED";

// Événement rattaché à un devis (éditeur : notes du brief, « devis envoyé »)
export const getEvenementByGrouped = (groupedId) => ({
  type: GET_EVENEMENT_BY_GROUPED,
  meta: {
    async: true,
    blocking: false,
    path: `/api/evenement/by-grouped/${groupedId}.json`,
    method: "GET",
    params: {},
  },
});

export const MARK_DEVIS_ENVOYE = "MARK_DEVIS_ENVOYE";

// Date d'envoi du devis = aujourd'hui, relances calées (depuis l'éditeur de devis)
export const markDevisEnvoye = (evenementId) => ({
  type: MARK_DEVIS_ENVOYE,
  meta: {
    async: true,
    blocking: true,
    path: `/api/evenement/${evenementId}/devis-envoye.json`,
    method: "POST",
    body: {},
  },
});

export const PATCH_DEVIS_TEMPERATURE = "PATCH_DEVIS_TEMPERATURE";

// Température commerciale d'un devis du board (CHAUD / TIEDE / FROID / null)
export const patchDevisTemperature = (groupedId, temperature) => ({
  type: PATCH_DEVIS_TEMPERATURE,
  meta: {
    async: true,
    blocking: false,
    path: `/api/evenement/pipeline/${groupedId}/temperature.json`,
    method: "PATCH",
    body: { temperature },
  },
});
